export default __webpack_public_path__ + "assets/img/139ed973f811ec6556c3484fbee7b14c.svg";